import React, { useContext } from "react";

import HeatingButton from "./HeatingButton";
import HotWaterButton from "./HotWaterButton";
import AwayButton from "./AwayButton";
import PriceButton from "./PriceButton";
import { AuthContext } from "../../AuthProvider";
import ControlPanelButton from "./ControlPanelButton";
import { ScreenContext } from "../../ScreenProvider";

const ControlPanelMenu = () => {

    const { esp } = useContext(AuthContext)
    const { isMobile } = useContext(ScreenContext)

    return (
        <>
            {esp && (
                <div>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                            <ControlPanelButton />
                            <HeatingButton />
                            <HotWaterButton />
                            <PriceButton />
                            {/*<WeatherButton />*/}
                            {isMobile && <AwayButton />}
                        </div>
                        {!isMobile && <AwayButton style={{ marginLeft: 'auto' }} />}
                    </div>
                </div>)}
        </>
    );
};

export default ControlPanelMenu;